import { BuildingIdType } from "../types/building";

import { UserServiceResponse } from "../services/userServiceServices";

const targetBuildingList: string[] = [
  "TG_0009537",
  "TG_0008066",
  "TG_0007100",
  "TG_0007126",
];

export const hideUnSupportService = (
  buildingId: BuildingIdType,
  service: UserServiceResponse
) => {
  if (targetBuildingList.includes(buildingId) && !service.serviceId) {
    return false;
  }

  return true;
};
